import React, { useState, useEffect } from 'react';

function Loading() {
  return (
    <>
      <div className='row flex-column justify-content-center h-100'>
        <img
          src='/Sobol_logo_upper.png'
          alt='Sobol Logo'
          className='mx-auto rotate align-self-end mb-3'
          style={{ width: '7%' }}
        />
        <img
          src='/Sobol_logo_lower.png'
          alt='Sobol Logo'
          className='mx-auto align-self-start'
          style={{ width: '20%' }}
        />
      </div>
    </>
  );
}

export default Loading;
